﻿import { Component } from '@basic-orange/component';

export default class Chatbot extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);

        this.settings = this.data;
        this.currentLocation = document.location.href;
        this.lastPageVisited = sessionStorage.getItem('lastpage') ? sessionStorage.getItem('lastpage') : sessionStorage.setItem('lastpage', this.currentLocation);
        this.setConfig(this.data);
        this.loadCxScript();
        this.setPage(this.currentLocation, this.lastPageVisited);

        this.widgets = document.querySelectorAll('.widget-chatbot');

        this.onChatbotReady(this.data);

        this.initWidgets();
        this.checkPreviousUrl();
    }

    setConfig(data) {
        window.cxcoConfig = {
            /* project/database configuration */
            /* engineUrl: 'cms', */
            session: {
                mode: this.settings.context,
                pageUrl: this.currentLocation
            },
            project: {
                publicApiKey: data.apikey,
                culture: data.language,
                customerKey: data.customerkey,
                key: data.projectkey
            },
            dci: {
                onloadEvent: 'Onload',
                layout: {
                    scrollType: 'answer',
                    initialState: this.currentLocation == this.lastPageVisited ? this.getStorageItem() : 'minimized',
                    inputPlaceholder: data.placeholder,
                    rows: 1,
                    dialogChooseAgain: data.chooseagain,
                    dialogNewChoice: data.newchoice,
                    showAvatar: true,
                    title: data.title,
                    isMenuOpen: true,
                    persistentState: true,
                    initialHeight: 34
                },
                feedback: {
                    /* Show global feedback on separate panel. default - false */
                    showGlobal: false,
                    /* Show interaction feedback - thumbs up/down. default - false  */
                    showThumbs: false,
                    /* Trigger default feedback on QA and dialog. default - false */
                    showDialog: true
                }
            }
        };

        window.cxco = window.cxco || [];
    }

    onChatbotReady(data) {
        cxco.push(['on', 'chatbot.ready', function () {
            try {
                //create element nodes
                window.buttonNode = document.createElement('button');
                window.overlayNode = document.createElement('div');
                window.closeButtonNode = document.createElement('div');
                window.inputCounterNode = document.createElement('div');

                window.overlayTitleNode = document.createElement('h2');
                window.overlayTextNode = document.createElement('div');
                window.overlayButtonNode = document.createElement('button');
                window.overlayLinkNode = document.createElement('a');
                window.closeButtonTextEl = JSON.parse(sessionStorage.getItem('cxco.dci')).messages.length ? data.buttonresumetext : data.buttoninittext;

                // add classes to element nodes
                overlayTextNode.classList.add('cxco-c-overlay-text');
                overlayButtonNode.classList.add('cxco-c-overlay-button');
                overlayLinkNode.classList.add('cxco-c-overlay-link');
                buttonNode.classList.add('cxco-c-open');
                overlayNode.classList.add('cxco-c-overlay');
                overlayNode.classList.add('closed');
                closeButtonNode.classList.add('cxco-c-action__text');
                inputCounterNode.classList.add('characters-left');

                // create text nodes
                window.overlayTitleText = document.createTextNode(data.overlaytitle);
                window.overlayText = document.createTextNode(data.overlaytext);
                window.overlayButtonText = document.createTextNode(data.overlaybuttontext);
                window.overlayLinkText = document.createTextNode(data.overlaylinktext);
                window.closeButtonText = document.createTextNode(closeButtonTextEl);
                window.inputCounterNodeText = document.createTextNode('100');

                // get chat elements
                window.parentDiv = document.getElementsByClassName('cxco-o-chat')[0];
                window.buttonCloseDiv = document.getElementsByClassName('cxco-c-action')[0];
                window.buttonMinimizeDiv = document.getElementsByClassName('cxco-c-close')[0];
                window.cxcoChatInput = document.getElementById('cxcoChatInput');
                window.cxcoChatInputParent = cxcoChatInput.parentNode;

                // add text and data nodes to element nodes
                overlayTitleNode.appendChild(overlayTitleText);
                overlayTextNode.appendChild(overlayText);
                overlayButtonNode.appendChild(overlayButtonText);
                overlayLinkNode.appendChild(overlayLinkText);
                closeButtonNode.appendChild(closeButtonText);
                buttonCloseDiv.dataset.resumetext = data.buttonresumetext;
                buttonCloseDiv.dataset.inittext = data.buttoninittext;
                inputCounterNode.appendChild(inputCounterNodeText);

                // add element nodes to overlay node
                overlayNode.appendChild(overlayTitleNode);
                overlayNode.appendChild(overlayTextNode);
                overlayNode.appendChild(overlayButtonNode);
                overlayNode.appendChild(overlayLinkNode);
                cxcoChatInputParent.appendChild(inputCounterNode);

                // Set title attribute on submit button
                const submitButton = cxcoChatInputParent.querySelector('.cxco-c-field__button:not(.cxco-u-hidden)');
                if (submitButton) submitButton.setAttribute('title', 'Submit');

                // init
                window.maxTextCharactersNumber = data.maxtextcharacters;
                updateCounter(maxTextCharactersNumber);
                setResumeButtonText('minimized', false);



                // add listners
                cxcoChatInput.onkeyup = function () {
                    updateCounter(maxTextCharactersNumber);
                };

                cxcoChatInput.onkeydown = function () {
                    updateCounter(maxTextCharactersNumber);
                };

                buttonMinimizeDiv.onclick = function () {
                    setResumeButtonText('minimized', false);
                };

                buttonCloseDiv.onclick = function () {

                    let PastDateTime = Date.parse(sessionStorage.getItem('livechatStart'));
                    let currentDateTime = Date.parse(new Date());

                    let msDifference = currentDateTime - PastDateTime;
                    let minutes = Math.floor(msDifference / 1000 / 60);
                    let days = Math.floor(minutes * 60 * 24);
                    if (days > 0 || minutes <= 60) {
                        window.openLiveChat();
                    } else {
                        setResumeButtonText('open', false);
                    }
                };

                buttonNode.onclick = function () {
                    if (overlayNode.classList.contains('closed')) {
                        overlayNode.classList.remove('closed');
                    } else {
                        overlayNode.classList.add('closed');
                    }

                };

                overlayButtonNode.onclick = function () {
                    closeChat();
                };

                overlayLinkNode.onclick = function () {
                    overlayNode.classList.add('closed');
                };

                // append elemets to chatbot
                buttonCloseDiv.appendChild(closeButtonNode);
                parentDiv.appendChild(buttonNode);
                parentDiv.appendChild(overlayNode);

                // init buttons after elements being added
                var $openClosebutton = $('.cxco-c-open')[0];
                var $hideButton = $('.cxco-c-close')[0];

                // set attributes on buttons end text input
                $openClosebutton.setAttribute('title', data.closebuttontitle);
                $hideButton.setAttribute('title', data.hidebuttontitle);
                cxcoChatInput.setAttribute('maxLength', maxTextCharactersNumber);
                cxcoChatInput.setAttribute('rows', '1'); // start textfield centered

                // get livechat elements




                // specific functions for chatbot
                window.openLiveChat = function () {
                    cxco.push(['changeState', { isOpen: false }]);
                    document.querySelectorAll('div[data-test-id]')[0].style.display = 'block';
                    sessionStorage.setItem('chatbotInitState', 'minimized');
                    window.userlike.userlikeStartChat();
                    sessionStorage.setItem('livechatStart', new Date());
                    setResumeButtonText('minimized', false);


                }



                function closeChat() {
                    cxco.push(['archive']);
                    cxco.push(['sendEvent', 'onLoad']);
                    overlayNode.classList.add('closed');
                    cxco.push(['changeState', { isOpen: false }]);
                    setResumeButtonText('minimized', true);
                }

                function updateCounter(maxNumber) {
                    var textAreaCount = cxcoChatInput.value.length;
                    var charactersLeft = maxNumber - textAreaCount;
                    inputCounterNode.innerHTML = charactersLeft;
                }

                function setResumeButtonText(openOrClose, reset) {
                    sessionStorage.setItem('chatbotInitState', openOrClose);
                    let hasMessages = JSON.parse(sessionStorage.getItem('cxco.dci')).messages.length > 2;
                    var closedButtonData = $('.cxco-c-action')[0].data();
                    var closeButtonText = !reset ? closedButtonData.resumetext : closedButtonData.inittext;
                    $('.cxco-c-action__text').text(closeButtonText);
                    let $chatbotButtonTextElements = $('.widget-chatbotButton-text');
                    $chatbotButtonTextElements.each((id, $element) => {
                        let text = hasMessages && !reset ? $element.dataset.changedtext : $element.dataset.defaulttext;
                        $element.innerHTML = text;
                    });
                }



                // observe chat input parent for newly added input/textarea, so the event listener can be added again
                const observer = new MutationObserver(function (mutations_list) {
                    mutations_list.forEach(function (mutation) {
                        mutation.addedNodes.forEach(function (added_node) {
                            if (added_node.id == 'cxcoChatInput') {
                                window.cxcoChatInput = added_node;
                                cxcoChatInput.setAttribute('maxLength', maxTextCharactersNumber);
                                cxcoChatInput.onkeyup = function () {
                                    updateCounter(maxTextCharactersNumber);
                                };

                                observer.disconnect();
                            }
                        });
                    });
                });

                observer.observe(cxcoChatInputParent, { subtree: false, childList: true });

                // concept for keeping dialog options open

                //var $optionDialog = $('.cxco-c-dialog__option');
                //$optionDialog.on('click', function () {
                //var $button = $(this);  

                //var $buttonListItem = $button.closest('.cxco-c-dialog__item');


                //    var $buttonList = $button.closest('.cxco-c-dialog');
                //    var $buttonContainer = $button.closest('.cxco-c-conversation__node');

                //    $button.toggleClass('active');
                //    $button.data('state', '');
                //    $buttonListItem.data('state', '');
                //    $buttonList.data('state', '');
                //    $buttonContainer.find('.cxco-c-reverter').remove();

                //});

            } catch (error) {
                console.log(error);
            }

            const widgets = document.querySelectorAll('.widget-chatbot');
            let isOpen = false;
            if (sessionStorage.getItem('cxco.dci')) isOpen = JSON.parse(sessionStorage.getItem('cxco.dci')).isOpen;
            if (widgets.length && !isOpen) window.buttonCloseDiv.classList.add('hide');
        }]);

        // reset counter and send feedback on answer
        cxco.push(['on', 'answer', function (answer) {
            inputCounterNode.innerHTML = maxTextCharactersNumber;

            if (answer.data.outputAdditions && answer.data.outputAdditions.hasOwnProperty('feedbackscore')) {
                const score = parseInt(answer.data.outputAdditions['feedbackscore'])

                cxco.push(['sendEvent', 'sendFeedback',
                    data = {
                        score,
                        label: score <= 0 ? 'no' : 'yes',
                        interactionId: answer.metadata.interactionId,
                        comment: answer.data.answer.replace(/(<\/?[^>]*>)|(%{DialogOption\([^)]*\)})/gmi, '')
                    }
                ]);
            }
        }]);
        cxco.push(['on', 'ask', function (answer) {
            if (answer.data && answer.data.hasOwnProperty('dialogPath')) {
                if (answer.data.dialogPath === '1480:2' && answer.data.userInput == 'Ja, ga naar de livechat') {
                    //start livechat
                    window.openLiveChat();

                }
            }
        }]);
    }

    setPage(currentpage, lastpage) {
        if (currentpage == lastpage) {
            return
        } else {
            sessionStorage.setItem('lastpage', currentpage)
        }
    }

    getStorageItem() {
        if (sessionStorage.getItem('chatbotInitState')) {
            return sessionStorage.getItem('chatbotInitState');
        } else {
            sessionStorage.setItem('chatbotInitState', 'open');
            return 'open';
        }
    }

    loadCxScript() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://projects.elitechnology.com/jsprojects/cxco/dci/3/init.js?v=' + (+new Date);
        script.async = true;

        var scriptTag = document.getElementsByTagName('script')[0];
        scriptTag.parentNode.insertBefore(script, scriptTag);
    }

    initWidgets() {
        this.widgets.forEach($widget => {
            const $input = $widget.querySelector('.widget-chatbotField');
            const $button = $widget.querySelector('.widget-chatbotButton');

            $button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const value = $input.value;
                if (value) {
                    cxco.push(['ask', value]);
                    $input.value = '';
                }

                window.buttonCloseDiv.classList.remove('hide');
                cxco.push(['changeState', { isOpen: true }]);
            });
        });
    }

    isPreviousUrlSameDomainAndNotRefresh() {
        const previousUrl = sessionStorage.getItem('previousUrl');
        const currentUrl = window.location.href;
        const currentHostname = window.location.hostname;

        if (!previousUrl) {
            sessionStorage.setItem('previousUrl', currentUrl);
            return false;
        }

        const previousUrlObj = new URL(previousUrl);
        sessionStorage.setItem('previousUrl', currentUrl);
        const result = previousUrlObj.hostname === currentHostname && previousUrl !== currentUrl;
        return result;
    }

    checkPreviousUrl() {
        let isOpen = false;
        if (sessionStorage.getItem('cxco.dci')) isOpen = JSON.parse(sessionStorage.getItem('cxco.dci')).isOpen;
        if (isOpen) {
            setTimeout(() => {
                if (this.isPreviousUrlSameDomainAndNotRefresh()) {
                    cxco.push(['changeState', { isOpen: false }]);
                }
            }, 500);
        }
    }
}
